import { Box, Tab, Tabs } from '@mui/material';

function SingleViewPageTabs({ activeTab, onTabSelect, tabHeaders }) {
  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
      <Tabs
        value={activeTab}
        onChange={(_, newValue) => onTabSelect(newValue)}
        variant="scrollable"
        scrollButtons="auto"
        textColor="primary"
        indicatorColor="primary"
      >
        {tabHeaders?.map((tab) => (
          <Tab
            key={tab.key}
            label={tab.label}
            value={tab.key}
            disableRipple
            sx={{
              textTransform: 'none',
              fontWeight: 500,
              fontSize: '0.875rem',
              minHeight: 44,
              px: 2,
            }}
          />
        ))}
      </Tabs>
    </Box>
  );
}

export default SingleViewPageTabs;